import {action, observable} from 'mobx';
import {ITranslate} from '../../services/LocalizationService';
import {TechseeBaseController} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-controller';
export enum ErrorDialogEvents {
    CLOSE = 'CLOSE',
    RETRY = 'RETRY'
}

export class ErrorDialogController extends TechseeBaseController {
    @observable isVisible: boolean = false;
    @observable message: string = '';
    @observable showRetryButton: boolean = false;

    constructor(
        public readonly isMobile: boolean,
        public readonly isMiniDashboard: boolean
    ) {
        super();
    }

    @action
    show = (message: string, showRetryButton: boolean = false): Promise<{retryDownload?: boolean}> => {
        this.message = message;
        this.showRetryButton = showRetryButton;
        this.isVisible = true;

        return new Promise((resolve) => {
            const onClose = (): void => {
                this.off(ErrorDialogEvents.CLOSE, onClose);
                this.off(ErrorDialogEvents.RETRY, onRetry);
                resolve({});
            };

            const onRetry = (): void => {
                this.off(ErrorDialogEvents.CLOSE, onClose);
                this.off(ErrorDialogEvents.RETRY, onRetry);
                resolve({retryDownload: true});
            };

            this.on(ErrorDialogEvents.CLOSE, onClose);
            this.on(ErrorDialogEvents.RETRY, onRetry);
        });
    };

    @action
    hide = (): void => {
        this.isVisible = false;
    };

    @action
    close = (): void => {
        this.hide();
        this.emit(ErrorDialogEvents.CLOSE);
    };

    @action
    retry = (): void => {
        this.hide();
        this.emit(ErrorDialogEvents.RETRY);
    };
}
